import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";

const AdminProtectedRoute = ({ component: Component, ...rest }) => {
  const { adminUser, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        adminUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/admin/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default AdminProtectedRoute;